import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function CursFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: 'Funcționează dacă nu câștig mult acum?',
    a: 'Da. Cursul schimbă relația ta cu banii indiferent de nivelul actual de venituri. Nu contează de unde pleci, ci ce crezi despre bani la nivel de subconștient. Asta schimbăm aici.'
  }, {
    q: 'Este un curs despre investiții sau strategie financiară?',
    a: 'Nu. Magnet pentru Bani lucrează cu mentalitatea și relația emoțională cu banii. E despre ce simți și ce crezi despre bani, nu despre unde să îi investești.'
  }, {
    q: 'În cât timp văd rezultate?',
    a: 'Unii participanți observă schimbări chiar în timpul cursului, în felul cum se simt și cum gândesc despre bani. Alții văd rezultate concrete în câteva săptămâni, pe măsură ce aplică exercițiile zilnic.'
  }, {
    q: 'Trebuie să cred în spiritualitate ca să funcționeze?',
    a: 'Nu e necesar. E suficient să fii deschis la ideea că emoțiile și credințele tale influențează relația cu banii. Restul vine natural pe parcursul cursului.'
  }, {
    q: 'Este potrivit pentru antreprenori?',
    a: 'Da, mai ales pentru antreprenori și freelanceri care simt blocaje în creșterea veniturilor. Multe dintre aceste blocaje nu sunt de strategie, ci de mentalitate. Și exact asta rezolvă acest curs.'
  }, {
    q: 'Pot cumpăra doar acest curs fără tot pachetul Academiei?',
    a: 'Da. Cursul se poate achiziționa separat la 500 lei cu acces pe viață. Dacă vrei toate cele 6 cursuri plus întâlniri de grup, Programul Standard complet costă 1.985 lei integral și economisești față de cumpărarea separată.'
  }, {
    q: 'Ce fac dacă am întrebări după ce parcurg cursul?',
    a: 'Dacă ai doar cursul individual, mă poți contacta direct. Dacă ești membru în Academie (Standard sau Premium), ai acces la întâlnirile săptămânale de grup unde poți pune orice întrebare și aprofunda.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-701">
      <div className="max-w-4xl mx-auto px-6" data-id="element-702">
        <SectionHeading title="Întrebări Frecvente" data-id="element-703" />

        <div className="space-y-4 mb-16" data-id="element-704">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-brand-text/10 rounded-2xl overflow-hidden bg-brand-cream/50" data-id="element-705">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-706">
                <span className="font-bold text-lg text-brand-text pr-8" data-id="element-707">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-708" />
              </button>
              <AnimatePresence data-id="element-709">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-710">
                    <div className="px-6 pb-5 text-brand-textSec leading-relaxed" data-id="element-711">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-712">
          <CTAButton data-id="element-713" />
        </motion.div>
      </div>
    </section>;
}